import { SortOptionType } from '@/types/srp'
import { capitalizeFirstLetter } from '@/utils'
import { ProcessedData } from '@/utils/srp/types'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { useState } from 'react'
import Pointer from '../../../itinerary/Desktop/icons/pointer.svg'

type SortOptionsType = {
    activeSort: SortOptionType[]
    setActiveSort: (activeSort: SortOptionType[] | ((prevState: SortOptionType[]) => SortOptionType[])) => void
    isLoading: boolean
    processedData: Partial<ProcessedData>
}

const SortOptionsFFOW: React.FC<SortOptionsType> = ({
    activeSort,
    setActiveSort,
    isLoading,
    processedData
}) => {
  const [selectedSort, setSelectedSort] = useState('Price');
  // As the user will scroll down the value will increase or not boolean, that means an up arrow
  const [isLowToHigh, setIsLowToHigh] = useState(true);
  const headingsObjArary = [{width: '114px', key: "departure"}, {width: '118px', key: "duration"}, {width: '264px', key: "arrival"}, {key: "price"}];

  if (isLoading) {
    return <></>
  }

  const handleFilterClick = (headingClicked: string, isUp: boolean) => {
    const newIsLowToHigh = headingClicked === selectedSort ? !isLowToHigh : true;
    setIsLowToHigh(newIsLowToHigh);
    setSelectedSort(headingClicked);

    const upOrDown = newIsLowToHigh ? "up" : "down";
    const sortType = newIsLowToHigh ? "asc" : "desc";
    
    setActiveSort([
      {
        title: "",
        sortType,
        sortKey: `${headingClicked}_${upOrDown}`,
        sortingBasis: headingClicked
      },
      {
        title: "",
        sortType,
        sortKey: `${headingClicked}_${upOrDown}`,
        sortingBasis: headingClicked
      }
    ]);
  }

  return (
    <Container className='flex br-4 py-2 px-6' style={{backgroundColor: '#f7f7f7'}}>
      <Container className='flex' width='156px'>
        <Typography variant='P3' color='subheading'>Airline</Typography>
      </Container>
      {headingsObjArary.map((headingObj) => {
        return (
          <Container className='flex' width={headingObj.width} onClick={() => handleFilterClick(headingObj.key, isLowToHigh)}>
            <Typography variant='P3' className='c-pointer mr-1 t-sentence' color={selectedSort === headingObj.key ? 'link2' : 'subheading'}>{capitalizeFirstLetter(headingObj.key)}</Typography>
            {selectedSort === headingObj.key && <Pointer width="5px" height="12px" style={{transform: isLowToHigh ? 'rotate(-180deg)' : '', color: '#3366CC', paddingTop: isLowToHigh ? '' : '4px' }}/>}
          </Container>
        );
      })}
    </Container>
  );
}

export default SortOptionsFFOW
